import React from "react";

import { SubmenuTitle } from "../components/SubmenuTitle";
import { Reactangle } from "./Reactangle";
import "../../styles/news.scss";
import { getNews } from "../../apis/api";
import { NewsInfo } from "../../models/system";
import pointer from "../../assets/images/pointer.png";

export class News extends React.Component {
    state = { infos: [] as NewsInfo[] }
    componentDidMount(): void {
        getNews(0, 10).then((data) => {

            this.setState({ infos: data });

        });
    }

    render(): React.ReactNode {

        return (
            <div className="openinfo" id="openinfo">
                <div className="cards">

                    <div className="card onlineorder">
                        <div className="card_title"><span>在线</span><img src={pointer}></img><span>预约</span></div>
                        <div className="card_notice">疫情期间 每日限流</div>
                        <div className="card_entry">个人预约入口</div>
                        <div className="card_entry">团队预约入口</div>
                        <div className="card_entry">亲子票预约入口</div>
                        <div className="card_entry">企事业和学校</div>
                        <div className="card_info">
                            <p>入馆需知</p>
                            <p>如果您需要陪同尚未办理二代身份证的未成年人参观博物馆，请提前预约亲子票</p>
                        </div>
                    </div>
                    <div className="card opentime">
                        <div className="card_title"><span>开放</span><img src={pointer}></img><span>时间</span></div>
                        <div className="card_content">
                            <div className="card_timeline"></div>
                            <div className="times">
                            <p><span className="time">09:00</span><br></br><span className="text">开放入馆时间</span></p>
                           
                            <p><span className="time">16:30</span><br></br><span className="text">停止入馆时间</span></p>
                            <p><span className="time">17:00</span><br></br><span className="text">闭馆时间</span></p>
                            </div>
                        </div>
                        <div className="card_info">
                            <p>本馆免费开放，除法定节假日，全年实现周一闭馆</p>
                            <p>遇有重大活动或重要设备设施维修保养时，可根据需要临时闭馆，届时将预先告示公众，详情请关洋太仓博物馆官网</p>
                        </div>
                    </div>
                    <div className="card commu">
                        <div className="card_title"><span>交通</span><img src={pointer}></img><span>指南</span></div>
                        <div className="left withpadding">
                            <div className="icon"></div>
                            <div className="content">
                            <p className="address"><span>地址：</span><span>上海东路100号（西门）</span></p>
                            <p className="bus"><span>公交：115、122、128、138、202、207、137（夜线）、211（夜线）、市政府上海路站均可到达。</span></p>
                            </div>
                        </div>
                        <div className="bus"/>
                    </div>
                </div>
                <div className="list" >
                    <div className="method">
                        <div className="listtitle"><span>参观</span><img src={pointer}></img><span>方式</span></div>
                        <hr></hr>
                        <ol>
                            <li>太仓博物馆实行“全员预约机制“，疫情期间每日限额，下午票当天16:30之前进馆；</li>
                            <li>每日门票约满为止，现场无预约名额，当日也无余票发放；</li>
                            <li>请在太仓官网或者小程序上进行预约，预约成功后，按照预约时间携带本人身份证原件或江苏省第三代社保卡原件进馆参观；</li>
                        </ol>
                        <div className="padding">注意事项</div>
                        <ol>
                        <li>馆内请勿吸烟</li>
                            <li>请勿触摸展品。</li>
                            <li>展馆拍照请勿使用闪光灯和三角架等专业器材。</li>
                            <li>大件行李请勿带入馆内，服务中心提供寄存服务。</li>
                            <li>请勿将各类管制刀具、打火机、危险品及宠物带入场馆。</li>
                            <li>参观车辆请在停车场指定位置有序停放。</li>
                            <li>酗酒者、衣冠不整者、无行为能力或许限制行为能力且无监护人陪伴者谢绝入馆。</li>
                            <li>其他有碍展品安全、影响观众参观者谢绝入馆。</li>
                            <li> 根据国家有关规定，除常设的基本陈列和以院藏文物为主的专题展览免费开放外，按照市场化运作举办的临时展览及展演不列入免费参观范围。</li>
                        </ol>
                    </div>
                    <div className="space"/>
                    <div className="order">
                        <div className="listtitle"><span>参观</span><img src={pointer}></img><span>方式</span></div>
                        <hr></hr>
                        <div className="padding1">注意事项</div>
                        <ol>
                        <li>太仓博物馆微信小程序；</li>
                            <li>太仓网站（点击进入，按步骤预约）。</li>
                        </ol>
                        <div className="padding">预约成功的观众按预约时间段必携带身份证或江苏省第三代社保卡，在进闸机口刷卡入场。</div>
                        <div className="padding">温馨提示:<br></br>
                        如果您需要陪同尚未办理二代身份证的未成年人参观博物馆，请提前预约亲子票</div>
                    </div>
                </div>
            </div>
        )
    }
}